export const dailyActivity = [
  {
    title: "Aula",
    time: "",
    paragraphs: [
      "A Kenzie conta com mais de 1.600 horas de conteúdo e projetos pensados para te ajudar a aprender a programar em menos de um ano.",
      "As aulas são gravadas e podem ser assistidas no horário e dia que você preferir. Aqui é o aluno que adapta o ritmo de estudos à sua rotina.",
      "Diferente de uma aula teórica, durante as aulas demonstrativas, além de você entender melhor os conceitos e programação, você vai ver na prática como desenvolvedores pensam, como resolvem problemas, quais atalhos usam e as boas práticas de um profissional de programação.",
    ],
  },
  {
    title: "Exercícios e projetos",
    time: "",
    paragraphs: [
      "Aqui na Kenzie você vai colocar a mão na massa desde o dia 01! Nossa metodologia prioriza justamente o 'aprender fazendo'. Acreditamos que somente colocando a mão na massa (diga-se teclado) que você realmente vai aprender a codar!",

      "Se bater aquela dúvida durante a prática você pode acionar o suporte dos nossos professores particulares, que fica disponível todos os dias da semana.",
    ],
  },
  {
    title: "Hora de desenvolver soft skills",
    time: "",
    paragraphs: [
      "Você terá suporte e apoio do nosso time de ensino para o desenvolvimento dos seus projetos, e também terá conteúdos e orientações para desenvolver suas soft skills, que hoje são tão valorizadas quanto as hard skills no mercado.",

      "Além, claro, de orientações e mentoria para sua carreira como o desenvolvimento do seu currículo, treinamento para entrevistas, mapeamento de competências, construção de imagem pessoal, portfólio e muito mais!",
    ],
  },
];
